/**
 * Constants for Product List module
 * Centralized configuration values
 */

// Pagination
export const ROWS_PER_PAGE = 10;

// Sort configuration
export const SORT_ORDER = {
  ASC: 1,
  DESC: -1,
};

// Status configuration
export const STATUS_CONFIG = {
  ACCEPTED: "accepted",
  APPROVED: "approved",
  PENDING: "pending",
  REJECTED: "rejected",
};

// Table headers
export const TABLE_HEADERS = {
  NUMBER: "#",
  IMAGE: "Image",
  PRODUCT_NAME: "Product Name",
  PRODUCT_NUMBER: "Product Number",
  CATEGORY: "Category",
  SUBCATEGORY: "Subcategory",
  DESCRIPTION: "Description",
  STATUS: "Status",
};

// Sortable fields
export const SORTABLE_FIELDS = {
  PRODUCT_NAME: "productName",
  PRODUCT_NUMBER: "productNumber",
  CATEGORY: "categoryName",
  SUBCATEGORY: "subcategoryName",
  STATUS: "status",
};
